export enum NotificationsScopes {
  CAN_VIEW = 'can_view_notifications',
  CAN_DELETE = 'can_delete',
}
